import {
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Modal,
} from '@chakra-ui/react'

const TikBoxModal = ({
  maxW = '490px',
  title,
  open,
  toggle,
  closable = true,
  position = 'center', // Add position prop: 'center', 'top-right', etc.
  ...props
}) => {
  // Position configurations
  const positionStyles = {
    center: {},
    'top-right': {
      position: 'fixed',
      top: '20px',
      right: '20px',
      bottom: 'auto',
      left: 'auto',
      transform: 'none',
    },
    'top-left': {
      position: 'fixed',
      top: '20px',
      left: '20px',
      bottom: 'auto',
      right: 'auto',
      transform: 'none',
    },
    'bottom-right': {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      top: 'auto',
      left: 'auto',
      transform: 'none',
    },
  }
  return (
    <Modal
      size="lg"
      onClose={() => toggle(false)}
      isOpen={open}
      isCentered={position === 'center'}>
      <ModalOverlay />
      <ModalContent
        position={'fixed'}
        bottom={window.innerWidth > 768 ? 'inherit' : 0}
        borderRadius="2xl"
        borderBottomRadius={window.innerWidth > 768 ? '2xl' : 0}
        paddingBottom={5}
        paddingTop={3}
        maxW={maxW}
        sx={positionStyles[position]}>
        <ModalHeader style={{ fontWeight: 700 }}>{title}</ModalHeader>
        {closable && <ModalCloseButton />}
        <ModalBody>{props.children}</ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default TikBoxModal
